// Lines/Drains subsection form field enum
export enum LinesDrainsFormField {
  LINES_DRAINS_SYSTEM_SUMMARY = 'medical-background/lines-drains/system-summary'
}
